import React from 'react';
import {useTranslation} from 'react-i18next';
import {Dropdown} from 'react-bootstrap';
import {Link} from 'react-router-dom';

/**
 * Menu « Actions » d'une ligne du tableau des modérateurs. `onAction(name)` reçoit :
 * edit, toggle, reset-password, logout, delete. Seul « Voir le détail » reste si le compte n'est pas gérable.
 */
const ActionsDropdown = ({admin, manageable, onAction}) => {
    const {t} = useTranslation();

    return (
        <Dropdown alignRight>
            <Dropdown.Toggle variant="light" size="sm" id={`moderateur-actions-${admin.id}`}>
                <i className="fa fa-ellipsis-h"></i>{' '}{t("Actions")}
            </Dropdown.Toggle>
            {/* position fixed : le menu n'est pas coupé par le défilement horizontal du tableau */}
            <Dropdown.Menu popperConfig={{strategy: 'fixed'}}>
                <Dropdown.Item as={Link} to={`/moderateurs/${encodeURIComponent(admin.email)}`}>
                    <i className="fa fa-eye mr-2"></i>{t("Voir le détail")}
                </Dropdown.Item>
                {manageable && (
                    <>
                        <Dropdown.Item as="button" type="button" onClick={() => onAction('edit')}>
                            <i className="fa fa-edit mr-2"></i>{t("Modifier")}
                        </Dropdown.Item>
                        <Dropdown.Item as="button" type="button" onClick={() => onAction('toggle')}>
                            {admin.actif
                                ? <><i className="fa fa-ban mr-2"></i>{t("Désactiver")}</>
                                : <><i className="fa fa-check mr-2"></i>{t("Activer")}</>}
                        </Dropdown.Item>
                        <Dropdown.Item as="button" type="button" onClick={() => onAction('reset-password')}>
                            <i className="fa fa-key mr-2"></i>{t("Réinitialiser le mot de passe")}
                        </Dropdown.Item>
                        {admin.tokens_count > 0 && (
                            <Dropdown.Item as="button" type="button" onClick={() => onAction('logout')}>
                                <i className="fa fa-sign-out mr-2"></i>{t("Fermer les sessions ouvertes")}
                            </Dropdown.Item>
                        )}
                        <Dropdown.Divider />
                        <Dropdown.Item as="button" type="button" className="text-danger" onClick={() => onAction('delete')}>
                            <i className="fa fa-trash mr-2"></i>{t("Supprimer")}
                        </Dropdown.Item>
                    </>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default ActionsDropdown;
